import { ADD_ITEM_IN_COMPARE_LIST, CREATE_COMPARE_LIST, DELETE_ITEM_FROM_COMPARE_LIST, GET_CATELOUGE, GET_COMPARE_LIST, GET_PROLOCATION } from "../gql/catalouge";
import client from "../graphqlClient";

export const getCatelouge = async (variables)=>{
    const options = {
        query: GET_CATELOUGE,
        variables: variables,
      };
    
      try {
        const response = await client.query(options);
        return response;
      } catch (error) {
        return error
      }
}
export const getCompareList = async (variables)=>{
  const options = {
      query: GET_COMPARE_LIST,
      variables: variables,
    };
  
    try {
      const response = await client.query(options);
      return response;
    } catch (error) {
      return error
    }
}
export const createCompareList = async (variables)=>{
  const options = {
      mutation: CREATE_COMPARE_LIST,
      variables: variables,
    };
  
    try {
      const response = await client.mutate(options);
      return response;
    } catch (error) {
      return error
    }
}
export const addItemInCompareList = async (variables)=>{
  const options = {
      mutation: ADD_ITEM_IN_COMPARE_LIST,
      variables: variables,
    };
  
    try {
      const response = await client.mutate(options);
      return response;
    } catch (error) {
      return error
    }
}
export const deleteItemFromComapreList = async (variables)=>{
  const options = {
      mutation: DELETE_ITEM_FROM_COMPARE_LIST,
      variables: variables,
    };
  
    try {
      const response = await client.mutate(options);
      return response;
    } catch (error) {
      return error
    }
}
export const getLocationDetail = async (variables)=>{
  const options = {
      query: GET_PROLOCATION,
      variables: variables,
    };
  
    try {
      const response = await client.query(options);
      return response;
    } catch (error) {
      return error
    }
}